import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectService } from 'src/app/services/project.service';
import { Project } from 'src/app/shared/models/project.model';

@Component({
    selector: 'app-project-list-item',
    templateUrl: './project-list-item.component.html',
    styleUrl: './project-list-item.component.scss',
    standalone: false
})
export class ProjectListItemComponent {
	@Input() item: any;
	@Input() toCollapsed: any;
	isCollapsed = false;
	projectObserve!: Observable<Project>;

	constructor(private projectService: ProjectService) {}

	toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

	goToProject() {
		this.projectService.setProject(this.item);
	}

}
